import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-white px-6 text-center" data-testid="payment-cancel-page">
      <XCircle size={56} strokeWidth={1} className="text-white/50 mb-8" />
      <h1 className="font-serif-display text-4xl md:text-5xl mb-5">Pago cancelado</h1>
      <p className="text-white/55 font-light max-w-md mb-10">
        No se realizó ningún cargo. Su membresía estará lista cuando usted lo desee.
      </p>
      <div className="flex gap-4">
        <Link to="/dashboard" className="bg-gold text-black px-9 py-4 text-xs tracking-luxe-sm uppercase hover:bg-[#C5A059] transition-colors" data-testid="cancel-dashboard-btn">
          Mi Suite
        </Link>
        <Link to="/" className="border border-white/25 px-9 py-4 text-xs tracking-luxe-sm uppercase hover:border-gold hover:text-gold transition-colors">
          Inicio
        </Link>
      </div>
    </div>
  );
}
